import React, { useMemo, useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { TOOL_REGISTRY } from "./toolRegistry";

function ChatToolsPlus({ onSelectTool, disabled = false }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const tools = useMemo(() => TOOL_REGISTRY, []);

  const handleOpen = (e) => {
    if (disabled) return;
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (toolId) => {
    onSelectTool?.(toolId);
    handleClose();
  };

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center" }}>
      <Tooltip title="Tools">
        <IconButton
          size="small"
          onClick={handleOpen}
          disabled={disabled}
          sx={{
            width: 28,
            height: 28,
            borderRadius: "6px",
            border: "1px solid rgba(0,0,0,0.12)",
            backgroundColor: "transparent",
          }}
        >
          <AddIcon sx={{ fontSize: 18, color: "#396d87" }} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {tools.map((tool) => {
          const Icon = tool.icon;
          return (
            <MenuItem key={tool.id} onClick={() => handleSelect(tool.id)}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <Icon sx={{ fontSize: 18, color: "#396d87" }} />
              </ListItemIcon>
              <ListItemText primary={tool.label} />
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
}

export default ChatToolsPlus;
